import React, {useEffect} from 'react';
import {PermissionsAndroid, Platform, View} from 'react-native';
import {IStateProps} from './model';
import {CreateRequestForm} from '../form';
import Screen from '../../../../../shared/components/screen';
import {useStyles} from '../../../../../shared/hooks/styles';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({onSuccessFormSubmit}: IStateProps) => {
  const styles = useStyles(() => ({
    sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 24,
    },
  }));

  const requestReadMediaPermissions = async () => {
    if (Number(Platform.Version) < 33) return;
    try {
      // @ts-ignore
      await PermissionsAndroid.request('android.permission.READ_MEDIA_IMAGES');
      // @ts-ignore
      await PermissionsAndroid.request('android.permission.READ_MEDIA_AUDIO');
      // @ts-ignore
      await PermissionsAndroid.request('android.permission.READ_MEDIA_VIDEO');
    } catch (err) {
      console.warn(err);
    }
  };

  useEffect(() => {
    requestReadMediaPermissions();
  }, []);

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='never'>
        <View style={styles.sectionContainer}>
          <CreateRequestForm onSuccessSubmit={onSuccessFormSubmit} />
        </View>
      </CustomScrollView>
    </Screen>
  );
};
